import userApi from "apis/userApi";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import logo from 'assets/images/logos/qr.png';

import QRCode from 'qrcode';
import { AgentRegLinkPayload } from "models/agentModel";
import styles from './account-option.style';
import LoadingIcon from "components/loading/LoadingIcon";

function AgentRegister() {
    const qrCodeRef = useRef<HTMLDivElement>(null);
    const [qrCode, setQrCode] = useState<HTMLCanvasElement | null>(null);
    const [regId, setRegId] = useState('');
    const [regLink, setRegLink] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        initAgentReg();
    }, []);

    const initAgentReg = async () => {
        try {
            const { data } = await userApi.agentUserAutoRegList({});
            if(!data.msg) {
                const qrCodeData = data;
                if(qrCodeData.length !== 0) {
                    const regIdData = qrCodeData[0].domain.split('/reg/')[1];
                    const newLink = qrCodeData[0].domain;
                    setRegId(regIdData);
                    setRegLink(newLink);
                    if(regIdData) {
                        generateQRCode(data[0].domain);
                    }
                }
            } else {
                toast.error(data.msg)
            }
        } catch (error) {
            console.log(error);
        }
    };

    const generateQRCode = async (link: string) => {
        let canvas = await QRCode.toCanvas(link, {errorCorrectionLevel: 'high', width: 160});

        // add logo center
        const imgDim = { width: 30, height: 30 }; // logo dimention
        var context = canvas.getContext('2d');
        var imageObj = new Image();
        imageObj.src = logo;
        imageObj.onload = function () {
            if (context) {
                context.drawImage(imageObj, canvas.width / 2 - imgDim.width / 2, canvas.height / 2 - imgDim.height / 2, imgDim.width, imgDim.height);
            }
        };
        setQrCode(canvas);
        if(qrCodeRef.current) {
            qrCodeRef.current.appendChild(canvas);
        }
    };

    const downloadQrCode = async () => {
        if(qrCode) {
            const imageSrc = qrCode.toDataURL('image/jpeg');
            const response = await fetch(imageSrc);
            const blobImage = await response.blob();

            const href = URL.createObjectURL(blobImage);
            const anchorElement = document.createElement('a');
            anchorElement.href = href;
            anchorElement.download = 'qrcode';

            document.body.appendChild(anchorElement);
            anchorElement.click();
            document.body.removeChild(anchorElement);
            window.URL.revokeObjectURL(href);
        }
    };

    const copyText = (text: string) => {
        navigator.clipboard.writeText(text);
        toast.success('Sao chép thành công!');
    };

    const createAgentLink = async () => {
        const payload: AgentRegLinkPayload = { rpointssc: 0, rpoint115: 0, rpointdp: 0 };
        try {
            const { data } = await userApi.agentCreateLink(payload);
            if(!data.msg) {
                toast.success('Tạo liên kết thành công');
                initAgentReg();
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <div className={`${styles.wrap} ${styles.mw800}`}>
                <div className={styles.title}>Liên Kết Đăng Ký</div>

                {/* block has qrcode */}
                <div className={styles.qrCode} style={{ display: qrCode ? 'flex' : 'none' }}>
                    <div className={styles.qrcodeWrap}>
                        <div className={styles.qrcodeIcon} ref={qrCodeRef}></div>
                        <div className={styles.ruleQr}>
                            <ul>
                                <li>
                                    Mỗi hội viên chỉ có <strong>1</strong> liên kết đăng ký.
                                </li>
                                <li>Tải xuống mã QR hoặc sao chép liên kết để gửi cho cấp dưới của bạn đăng ký.</li>
                            </ul>
                            <button type="button" className={`btn-reg ${styles.btnSubmit}`} style={{ width: '160px', marginTop: '16px', padding: '10px' }} onClick={downloadQrCode}>
                                Tải ảnh QR
                            </button>
                        </div>
                    </div>
                    <div className={`${styles.agentQr}`}>
                        <div>
                            <p>Link đại lý:</p>
                            <div className={styles.agentItem}>
                                <span>{regLink}</span>
                                <button type="button" className={`btn-primary`} onClick={() => copyText(regLink)}>
                                    <img src={require('assets/images/icons/copy.png')} alt="" /> Sao chép
                                </button>
                            </div>
                        </div>
                        <div>
                            <p>Mã đại lý:</p>
                            <div className={styles.agentItem}>
                                <span>{regId}</span>
                                <button type="button" className={`btn-primary`} onClick={() => copyText(regId)}>
                                    <img src={require('assets/images/icons/copy.png')} alt="" /> Sao chép
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* block no qrcode */}
                <div className={qrCode ? 'hidden' : 'qrCode'}>
                    <ol className={styles.generateQr}>
                        <li>
                            Mỗi hội viên có <span>[1]</span> liên kết đăng ký.
                        </li>
                        <li>
                            Sau khi thiết lập liên kết đăng ký, nhấn vào <span>[Sao chép]</span> hoặc <span>[Truy cập]</span> để truy cập vào liên kết.
                        </li>
                    </ol>
                    <div style={{ marginTop: '28px', width: '400px' }}>
                        <button type="button" className={`${styles.btnSubmit} btn-primary`} onClick={createAgentLink}>
                            Tạo Liên Kết
                        </button>
                    </div>
                </div>
            </div>
            {loading && <LoadingIcon />}
        </>
    )
}

export default AgentRegister;
